import React, { Component } from 'react';
import { Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";
import { toast } from 'react-toastify';

import CustomModal from "../../components/Modal/CustomModal";

import { CustomCard } from "../../components/Card/CustomCard";
import { ConsultaSolicitud, GenerarSolicitud, ConsultHistoricoSol } from '../../funciones/ConstanciaFunction';
import MensajeRetraso from "../../shared/MensajeRetraso";
import { ConsultaDeuda } from '../../funciones/EstCuentaFunction';
import { InfoUC } from '../../funciones/InscripcionFunction';
import { Precios } from '../../funciones/AdministracionFunction';
import { formatNumber, formatReconver } from "../../funciones/GeneralFunctions";

let statusBtn = 0;
let statusBtn2 = "";
let token = "";
let fecha = "";
let statusConst = 0;
let deudaTSolic = "";

class CargaHoraria extends Component {
    state = {
        status: {
            icon: "fa fa-spinner fa-spin",
            text: "Verificando, espera por favor",
            class: "custom-alert-info",
            styles:{fontSize:12, position:"absolute", top: 4}
        },
        constancias: [],
        button: {
            icon: "fa fa-file",
            text: "Solicitar Certificación"
        },
        datosEst:"",
        ValorUc: "",
        valorTramite: {
            uc: "",
            bs: ""
        },
        openW: false,
        boton2: {
            icon: "fa fa-check",
            text: "Si",
            disabled: false
        },
        deudaT: ""
    }

    constructor (props) {
        super (props);
        ConsultHistoricoSol ("CARGA HORARIA", (status) => {
            statusConst = status;
        })

        ConsultaSolicitud ("CARGA HORARIA", (resp) => {
            statusBtn = resp[3]
            statusBtn2 = resp[4]
            this.setState({
                status: resp[0],
                constancias: resp[1],
                datosEst: resp[2]
            })
        })

        InfoUC ((resp) => {
            this.setState({ValorUc: resp})
        })

        Precios("CARGA HORARIA", (resp) => {
            this.setState({valorTramite: resp})
        })
    }

    componentDidMount = () => {
        ConsultaDeuda ((resp) => {
            deudaTSolic = resp.deudaVencida
            this.setState({deudaT: resp.deudaVencida})
        })
    }

    botones = () => {
        let { button } = this.state;

        if (deudaTSolic === "") return (
            <Col md ={12} className="custom-mt-10">
                <div className="text-danger" align = "center"><i className="fa fa-spinner fa-spin"></i> Buscando Información, espera</div>
            </Col>
        )

        if (deudaTSolic > 0) return (<MensajeRetraso />)
        
        
        switch (statusBtn) {
            case 0:
                if (statusConst > 0 ) {
                    let contenido = (
                        <Popover bsSize="large" title="Importante" id="Inscrito">
                            <div className="custom-alert-danger" align="center">Tienes solicitudes abiertas</div>
                            <div align="justify" className="custom-mt-10">
                                Ya has hecho una petición de este tipo, espera que su estatus cambie para poder realizar una nueva petición
                            </div>
                        </Popover>
                    )

                    return (
                        <div className="btn-group" role="group">
                            <OverlayTrigger trigger="focus" placement="right" overlay={contenido}>
                                <button style={{borderWidth: 1}} className="btn btn-primary"><i className={button.icon}></i> {button.text}</button>
                            </OverlayTrigger>
                        </div>
                    )
                }else{
                    if (statusBtn2 > 0){

                        let contenido2 = (
                            <Popover bsSize="large" title="Importante" id="Inscrito">
                                <div className="custom-alert-danger" align="center">Tienes solicitudes abiertas</div>
                                <div align="justify" className="custom-mt-10">
                                    Ya has hecho una petición de este tipo, espera que su estatus cambie para poder realizar una nueva petición
                                </div>
                            </Popover>
                        )
    
                        return (
                            <div className="btn-group" role="group">
                                <OverlayTrigger trigger="focus" placement="right" overlay={contenido2}>
                                    <button style={{borderWidth: 1}} className="btn btn-primary"><i className={button.icon}></i> {button.text}</button>
                                </OverlayTrigger>
                            </div>
                        )
                    }

                    return (
                        <button className="btn btn-primary" onClick = {()=> {this.setState({openW: true})}} style={{borderWidth: 1}}><i className={button.icon}></i> {button.text}</button>
                    )
                }
            case 1:
                let contenido = (
                    <Popover bsSize="large" id="Inscrito">
                        <div className="custom-alert-danger" align="center">No estas inscrito</div>
                        <div align="justify" className="custom-mt-10">
                            Para poder generar esta solicitud primero debes formalizar tu inscripción
                        </div>
                    </Popover>
                )

                return (
                    <div className="btn-group" role="group">
                        <OverlayTrigger trigger="focus" placement="right" overlay={contenido}>
                            <button style={{borderWidth: 1}} className="btn btn-primary"><i className={button.icon}></i> {button.text}</button>
                        </OverlayTrigger>
                    </div>
                )
            case 2:
                let contenido2 = (
                    <Popover bsSize="large" id="Inscrito">
                        <div className="custom-alert-danger" align="center">Importante</div>
                        <div align="justify" className="custom-mt-10">
                            Tu inscripción aun no está aprobada, espera que la aprueben para poder generar una Certificación
                        </div>
                    </Popover>
                )

                return (
                    <div className="btn-group" role="group">
                        <OverlayTrigger trigger="focus" placement="right" overlay={contenido2}>
                            <button style={{borderWidth: 1}} className="btn btn-primary"><i className={button.icon}></i> {button.text}</button>
                        </OverlayTrigger>
                    </div>
                )
            default:
                return (
                    <button className="btn btn-primary" style={{borderWidth: 1}} title="Presiona F5 para refrescar esta página"><i className="fa fa-times"></i> Error al Cargar</button>
                )
        }
    }

    contenido = () => {
        let { constancias, ValorUc, valorTramite } = this.state;
        const styles = {
            padding: 5, fontSize: 12
        }

        let constanciasS = () => {
            if (constancias === undefined) {
                return (
                    <tr>
                        <td width="100%" colSpan={3} style={styles} align="center">No has generado ninguna certificación</td>
                    </tr>
                )
            }

            if (constancias.length === 0) {
                return (
                    <tr>
                        <td width="100%" colSpan={3} style={styles} align="center">No has generado ninguna certificación</td>
                    </tr>
                )
            }else{
                let status = (status) => {
                    switch (parseInt(status)) {
                        case 0:
                            return <div className="text-warning"><i className="fa fa-money"></i> PAGO PENDIENTE </div>;
                        case 1:
                            return <div className="text-warning"><i className="fa fa-exclamation-circle"></i> PENDIENTE POR CONTROL DE ESTUDIOS</div>;
                        case 2:
                            return <div className="text-success"><i className="fa fa-check-circle"></i> APROBADA</div>;
                        case 3:
                            return <div className="text-danger"><i className="fa fa-times-circle"></i> NO APROBADA</div>;
                        default:
                            return 'PENDIENTE';
                    }
                }

                return(
                    constancias.map(option => (
                        <tr key={option.id}>
                            <td style={styles}>{`CERTIFICACIÓN N° - [${(option.token).substr(0,10)}]`}</td>
                            <td align="center" style={styles}>{option.fecha}</td>
                            <td align="center" style={styles}>{status(option.status)}</td>
                        </tr>
                    ))
                )
            }
        }

        let facturacion = () => (
            <Col md={12}>
                <div className="custom-mt-10 text-danger" align="right">
                    Valor actual de la Unidad de Crédito: <span className="badge badge-red">{formatNumber(ValorUc)} Bs.{/*  | {formatReconver(ValorUc)} Bs. */}</span>
                </div>
                <div align="right">
                    Este trámite tiene un costo de <strong>{valorTramite.uc} U.C.</strong> o <strong>{formatNumber(valorTramite.bs)} Bs.{/*  | {formatReconver(valorTramite.bs)} Bs. */}</strong>
                </div>
            </Col>
        )

        return (
            <Row>
                <Col md={12}>{facturacion()}</Col>
                <Col md ={12} className="custom-mt-10"><div className="custom-alert-info" style={{padding:5}}>Mi historial de Certificaciones de Carga Horaria</div></Col>
                <Col md ={12} className="custom-mt-10">
                    <div className="table-responsive">
                        <Table striped hover bordered>
                            <tbody>
                                <tr>
                                    <td width="50%" style={styles}>Solicitud</td>
                                    <td width="25%" align="center" style={styles}>Fecha</td>
                                    <td width="25%" align="center" style={styles}>Estatus</td>
                                </tr>
                                {constanciasS()}
                            </tbody>    
                        </Table>
                    </div>
                </Col>
                <Col md ={12} className="custom-mt-10" align="right">
                    {this.botones()}
                </Col>
            </Row>
        )
    }

    ayuda = () => (
        <Row align="justify">
            <Col md={12}>
                En este módulo podrás solicitar tu Certificación de Carga Horaria. Solo podrás usarlo una vez termines todas las asignaturas corespondientes a la carrera
            </Col>
            <Col md={12} className="custom-mt-10">
                Para esto haz click en el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-file"></i> Solicitar Certificación</button> y espera que el Estatus de tu petición cambie.
            </Col>

            <Col md={12} className="custom-mt-10">
                <span className="text-warning" style={{fontSize: 10}}><i className="fa fa-money"></i> PAGO PENDIENTE </span>
            </Col>
            <Col md={12} style={{fontSize: 11}}>
                Indica que la solicitud está en proceso. Debes cancelar los aranceles en Administración o hacer la transferencia y registrarla en <strong>ESTADO DE CUENTA</strong>
            </Col>
            <Col md={12} className="custom-mt-10">
                <span className="text-warning" style={{fontSize: 10}}><i className="fa fa-exclamation-circle"></i> PENDIENTE POR CONTROL DE ESTUDIOS</span>
            </Col>
            <Col md={12} style={{fontSize: 11}}>
                El pago de los aranceles de la solicitud ya fue verificado, debes esperar la aprobación de Control de Estudios
            </Col>
            <Col md={12} className="custom-mt-10">
                <span className="text-danger" style={{fontSize: 10}}><i className="fa fa-times-circle"></i> NO APROBADA</span>
            </Col>
            <Col md={12} style={{fontSize: 11}}>
                Indica que la petición fue rechazada. Debes soicitar una nueva o dirigirte al Departamento de Control de Estudios
            </Col>
            <Col md={12} className="custom-mt-10">
                <span className="text-success" style={{fontSize: 10}}><i className="fa fa-check-circle"></i> APROBADA</span>
            </Col>
            <Col md={12} style={{fontSize: 11}}>
                Indica que la petición está lista y puedes pasar a retirar la Certificación al Departamento de Control de Estudios
            </Col>

            <Col md={12} className="custom-mt-10">
                <strong>Mi historial de Certificaciones de Carga Horaria</strong>
            </Col>
            <Col md={12} className="custom-mt-10">
                Aqui puedes ver la cantidad de documentos de este tipo que has solicitado
            </Col>

            <Col md={12} className="custom-mt-10" style={{fontSize:11}}>
                <strong>Importante: El código de verificación del documento se actualizará cuando se genera una nueva Certificación en un dia diferente y todas las constancias anteriores no podrán ser validadas electrónicamente</strong>
            </Col>
        </Row>
    )

    generarC = () => (e) => {
        if (this.state.boton2.disabled === true) return null;
        this.setState({
            boton2: {
                icon:"fa fa-spinner fa-spin",
                text: "Espera",
                disabled: true
            }
        })

        GenerarSolicitud("CARGA HORARIA", (resp) => {
            let data = JSON.parse(resp)
            token = data.token
            fecha = data.fecha
            this.setState({
                openW: false,
            },() => {
                ConsultHistoricoSol ("CARGA HORARIA", (status) => {
                    statusConst = status;
                })

                ConsultaSolicitud ("CARGA HORARIA", (resp) => {
                    statusBtn = resp[3]
                    this.setState({
                        status: resp[0],
                        constancias: resp[1],
                        boton2: {
                            icon: "fa fa-check",
                            text: "Si",
                            disabled: false
                        }
                    })
                })
                toast.info("Solicitud del documento completada. Puedes revisar el status de esta solicitud desde este módulo",{autoClose: 4000});
            })
        })
    }

    showModal = () => {
        let { boton2, valorTramite } = this.state;
        let contenidoModal = () => (
            <React.Fragment>
                <div>¿Deseas solicitar una Certificación de Carga Horaria?</div>
                <div style={{fontSize:10}}>Esta opción no puede deshacerse y no podrás solicitar otra hasta que esta sea respondida</div>
                <div style={{fontSize:12}}>Este trámite tiene un costo de <strong className="text-danger">{valorTramite.uc} U.C.</strong> o <strong className="text-danger">{formatNumber(valorTramite.bs)} Bs.{/*  | {formatReconver(valorTramite.bs)} Bs. */}</strong> y se añadirá  automáticamente a tu estado de cuenta. <div><strong>Solicítala únicamente si ya has culminado todas las asignaturas de tu carrera</strong></div></div>
            </React.Fragment>
        )
        return (
            <CustomModal
                isopen =  {this.state.openW}
                titulo = {<div className="text-primary">Confirmación</div>}
                contenido = {contenidoModal()}
                boton1 = {<React.Fragment><i className= {boton2.icon}></i> {boton2.text}</React.Fragment>}
                boton2 = {<React.Fragment><i className= "fa fa-times"></i> No</React.Fragment>}
                funcion1 = {this.generarC()}
                funcion2 = {() => {this.setState({openW: false})}}/>
        );
    }

    render() {
        let { status } = this.state;
        return (
            <React.Fragment>
                <div className="content">
                    <Row>
                        <Col md={8}>
                            <div className={status.class} style={{padding:10}}>
                                <Row>
                                    <Col md={11}><div style={{fontSize:14}}>{status.text}</div></Col>
                                    <Col md={1}><i className={status.icon} style={status.styles}></i></Col>
                                </Row>
                            </div>
                            <Row className="custom-mt-10">
                                <Col md={12}>{this.contenido()}</Col>
                            </Row>
                        </Col>
                        <Col md={4}>
                            <div style={{borderRadius: "4px 4px",}}>
                                <CustomCard
                                    styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                    title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                    category={<span style={{color: "#fff"}}>Certificación de Carga Horaria</span>}
                                    color="#a80012"
                                    content={this.ayuda()}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
                {this.showModal()}
            </React.Fragment>
        );
    }
}

export default CargaHoraria;


// WEBPACK FOOTER //
// ./src/views/EstConsultas/CargaHoraria.jsx